import MetricBase from "models/metrics/MetricBase";
import EmptyUnit from "models/metrics/unit/EmptyUnit";
import i18n from "i18next";
import ConnectivityGroup from "../../../../groups/ConnectivityGroup";

class MetricHotelSuspendedCountGhaPPA extends MetricBase {
    constructor() {
        super({
            field: "metric_hotelSuspendedCount",
            defaultVisibility: true,
            unit: new EmptyUnit(),
            chartName: i18n.t("metrics.google_hotel_ads_ppa.hotelSuspendedCount.chartName"),
            serieLabel: i18n.t("metrics.google_hotel_ads_ppa.hotelSuspendedCount.serieLabel"),
            tooltip: i18n.t("metrics.google_hotel_ads_ppa.hotelSuspendedCount.tooltip"),
            group: new ConnectivityGroup(),
        });
    }
}

export default MetricHotelSuspendedCountGhaPPA;
